import React, { useEffect, useState } from 'react';
import { fetchUsers, upsertUser } from '../../services/Administracion/usersService';
import { User } from "../../types/users"
import UserModal from './UserModal';
import { useAuth, UserType } from '../../context/AuthContext';
import { Role } from '../../types/userRoles';
//import { impersonate } from '../../utils/api';
import { impersonate } from '../../services/Administracion/usersService';
import { LoginResponse } from '../../types/auth';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { set } from 'date-fns';

const RolesComponent: React.FC = () => {
    const { user: userContext } = useAuth(); //usuario del contexto
    const [users, setUsers] = useState<User[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [selectedUser, setSelectedUser] = useState<User>({ user_id: 0, ad_username: '', full_name: '', is_active: true, created_by: '', date_created: '', roles: [] });
    const [showUserModal, setShowUserModal] = useState<boolean>(false);
    const [filteredUsers, setFilteredUsers] = useState<User[]>([]); // Estado para usuarios filtrados
    const { login: authenticateUser } = useAuth();
    const navigate = useNavigate();


    useEffect(() => {
        fetchUsers()
            .then((data) => {
                // Procesar roles: Deserializar el campo roles para cada usuario
                const processedUsers = data.map((user: User) => ({
                    ...user,
                    //roles: user.roles ? JSON.parse(user.roles) : [], // Convertir JSON string a objeto
                    roles: typeof user.roles === 'string' ? JSON.parse(user.roles) : user.roles || [],
                }));
                setUsers(processedUsers);
                setFilteredUsers(processedUsers); // Inicialmente, mostrar todos los usuarios
                console.log('Datos en el fetch de usuarios: ', data);
            })
            .catch((error) => {
                console.error("Error fetching users: ", error);
                setError(error.message || "Error fetching users");
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const handleAddEditRole = (user?: User) => {
        //const userWhitoutDomain = ad_username.includes('@') ? ad_username.split('@')[0] : ad_username;
        //const userWithoutDomain = userContext?.User.email && userContext?.User.email.includes('@') ? userContext?.User.email.split('@')[0] : '';
        //console.log('usuario en HandleAddEditRole: ',userWithoutDomain);
        console.log('Usuario por editar : ', user);
        setSelectedUser(user || { user_id: 0, ad_username: '', full_name: '', is_active: true, created_by: userContext?.User.email || '', date_created: '', roles: [] });
        setShowUserModal(true);
    }

    const handleDesactivar = (user?: User) => {
        console.log('Usuario por desactivar : ', user);
    }

    const handleImpersonate = async (user?: User) => {
        if (user?.roles.length === 0) {
            Swal.fire({
                title: "Atención!!",
                text: "El usuario debe tener al menos un role",
                icon: "error",
                confirmButtonText: 'OK'
            });
            return;
        }


        try {
            console.log('Usuario por impersonar : ', user);
            let data: LoginResponse;

            if (!user?.user_id) return;

            //llama al backend para traer datos del usuario
            data = await impersonate({ userID: user.user_id });

            if (data) {
                const userImpersonated: UserType = {
                    User: {
                        name: data.user.name,
                        position: data.user.position,
                        email: data.user.email,
                        role: data.user.role
                    },
                    token: data.token,
                    permissions: data.user.permissions || [] // Asignar permisos del usuario
                };


                if (!localStorage.getItem('userAdmin')) {
                    localStorage.setItem('userAdmin', JSON.stringify(userContext));
                    localStorage.setItem('token', JSON.stringify(userContext?.token));
                    // sessionStorage.setItem('userAdmin', JSON.stringify(userContext));
                    // sessionStorage.setItem('token', JSON.stringify(userContext?.token));
                }
                authenticateUser(userImpersonated);
                //navigate('/dashboard');
                navigate('/');
                window.location.reload();
            }

        } catch (error: any) {
            console.log('Error al impersonar: ', error.message);
        }



    }

    const handleSaveUser = async (user: User, rolesAsignados: Role[], rolesBorrados: Role[]) => {
        console.log('Usuario por crear: ', user)
        setLoading(true);
        try {
            if (user.user_id) {
                user.updated_by = userContext?.User.email;
                console.log('Role antes de update: ', user);
            } else {
                user.created_by = userContext?.User.email || '';
                console.log('User antes de create: ', user);
            }
            upsertUser(user, rolesAsignados, rolesBorrados);

            fetchUsers()
                .then((data) => {
                    const processedUsers = data.map((user: User) => ({
                        ...user,
                        roles: typeof user.roles === 'string' ? JSON.parse(user.roles) : user.roles || [],
                    }));
                    setUsers(processedUsers);
                    setFilteredUsers(processedUsers);
                }).catch((error) => {
                    console.error("Error fetching users: ", error);
                    setError(error.message || "Error fetching users");
                })
                .finally(() => {
                    setLoading(false)
                });
        } catch (err: any) {
            setError(err.message || "Error saving user");
        } finally {
            setShowUserModal(false);
        }
    }

    if (loading) return <div className='container mt-4'>Cargando roles...</div>;
    if (error) return <div className='container mt-4 text-danger'>Error en el componente: {error}</div>;

    return (
        <div className='container mt-4' >
            <h1 className='mb-4'>Mantenimiento de Usuarios</h1>
            <div className='mb-3 text-end'>
                <button className='btn btn-primary' onClick={() => handleAddEditRole()}>Crear Usuario</button>
                <input type="text" className='form-control mt-2 mb-2' placeholder='Buscar por nombre o usuario'
                    onChange={(e) => {
                        const searchTerm = e.target.value.toLowerCase();
                        if(searchTerm === '') {
                            setFilteredUsers(users);
                            return;
                        }
                        const filteredUsers = users.filter(user =>
                            user.full_name.toLowerCase().includes(searchTerm) ||
                            user.ad_username.toLowerCase().includes(searchTerm)
                        );
                        setFilteredUsers(filteredUsers);
                    }} />
            </div>
            <div className="mt-0" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                <table className='table table-stripped table-hover' style={{ maxHeight: '500px', overflowY: 'auto' }}>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Nombre</th>
                            <th>Usuario</th>
                            <th>Activo</th>
                            <th>Roles Asignados</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUsers.map((user: User) => (
                            <tr key={user.user_id}>
                                <td>{user.user_id}</td>
                                <td>{user.full_name}</td>
                                <td>{user.ad_username}</td>
                                <td>{user.is_active ? 'Si' : 'No'}</td>
                                <td>
                                    <div className='d-flex flex-wrap gap-2'>
                                        {user.roles && user.roles.slice(0, 5).map((role, index) => (
                                            <span key={index} className="badge bg-primary" >
                                                {role.role_name}
                                            </span>
                                        ))}
                                        {user.roles.length > 5 && (
                                            <span
                                                className="badge bg-secondary"
                                                title={user.roles.slice(5).map(r => r.role_name).join(', ')}
                                            >
                                                +{user.roles.length - 5} más
                                            </span>
                                        )}
                                    </div>

                                </td>
                                <td>
                                    <button
                                        className='btn btn-sm btn-secondary me-2'
                                        onClick={() => handleAddEditRole(user)}
                                    >
                                        Editar
                                    </button>

                                    <button className='btn btn-sm btn-danger me-2' onClick={() => handleDesactivar(user)}>Desactivar</button>
                                    <button
                                        //<FontAwesomeIcon icon="fa-solid fa-user-secret" style={{color: "#63E6BE",}} />
                                        className={`btn  me-2 fa-solid fa-user-secret ${user.ad_username === userContext?.User.email.split('@')[0] ? 'd-none' : ''}`}
                                        disabled={user.ad_username === userContext?.User.email.split('@')[0]}
                                        title={`Impersonar a usuario ${user.ad_username} con ${userContext?.User.email.split('@')[0]}`}
                                        onClick={() => handleImpersonate(user)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {showUserModal && selectedUser && (
                <UserModal
                    user={selectedUser}
                    onClose={() => setShowUserModal(false)}
                    onSave={handleSaveUser}
                />
            )}
        </div>
    )

}

export default RolesComponent;